export const defaultState = {
  loading: false,
  strongPassword: true,
  user: {},
};
